// extracted by mini-css-extract-plugin
export default {"toggleGroup":"TrimesterTabs_toggleGroup__j2ll7"};